module.exports = __webpack_public_path__ + "img/guanbi.5f8aaa7b.png";